module.exports = __webpack_public_path__ + "static/media/Seawatergreenhouseaus_crop_twitter.5c07dbe0.jpg";